export class LookupViewModel {
  id?: string | null;
  name: string | null;
  description: string | null;
  sortValue: number | null;
  isActive: boolean | null;

  constructor(
    id: string | null,
    name: string | null,
    description: string | null,
    sortValue: number | null,
    isActive: boolean | null
  ) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.sortValue = sortValue;
    this.isActive = isActive;
  }

  toDto(): any {
    throw new Error("toDto method must be implemented in the subclass.");
  }

  mapFromDto(dto: any): void {
    throw new Error("mapFromDto method must be implemented in the subclass.");
  }
}
